import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Route } from '~/Constants/Routes.constants';
import { useNavigation, useNavigationContext } from '~/Hooks';
import { IItemCreationSectionInjectedProps } from '~/ModularComponents';
import { useRequestProviderCreate } from '~/requests';
import { IOrgStudios } from './Studio.model';
import { studioValidationScheme } from './studioValidation';
import { isObjectEmpty } from '~/Helpers/CleanData.helper';

export const useStudioCreation = () => {
  const { blockNavigation } = useNavigationContext();
  const { dangerouslyNavigate } = useNavigation();
  const { t } = useTranslation();
  const { isLoading, mutate: createProvider, error, isSuccess } = useRequestProviderCreate();
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const initialValues = {
    name: '',
    country: '',
    countryName: t('form.field.location.country'),
    category: 0,
    city: '',
    street: '',
  };

  const onSave = (store: IItemCreationSectionInjectedProps<IOrgStudios>) => {
    const studio = store.values;
    createProvider(studio);
  };

  const validate = useCallback((validateStudio: IOrgStudios) => {
    const shouldDisable = !isObjectEmpty(validateStudio);
    setIsSubmitDisabled(shouldDisable);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      blockNavigation(false);
      dangerouslyNavigate(Route.ORGANISATION_ROOT);
    }
  }, [isSuccess]);

  return {
    onSave,
    initialValues,
    error,
    isLoading,
    modalTitle: t('settings.provider.studio.create'),
    validationSchema: studioValidationScheme(t),
    validate,
    isSubmitDisabled,
  };
};
